import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IOrganizerState }      from 'Redux/Slices/Organizer/OrganizerSlice';
import { Organizer }            from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findOrganizersRequest = (state: Draft<IOrganizerState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findOrganizersSuccess = (state: Draft<IOrganizerState>, { type, payload }: PayloadAction<{
  organizers: Record<string, Organizer>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.organizers;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findOrganizersFailure = (state: Draft<IOrganizerState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
